module.exports = __webpack_public_path__ + "static/media/print.84c62921.svg";